import styled from "@emotion/styled";
import { mobileToTabletQuery } from "../../utils/mediaqueries";

export const Container = styled.div(
  {
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    cursor: "pointer",
  },
  ({ sideMargin }) => ({
    [mobileToTabletQuery]: {
      marginLeft: sideMargin ? "20px" : 0,
    },
  }),
);
